import { ExamCenterProctorType } from '@exam-center/graphql';
import { ProctorTypeLabel } from '@exam-center/proctor-management';
import { type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

export interface ExamCenterProctorListItem {
  id: string;
  fullName: string;
  type: ExamCenterProctorType;
  approvalDate: Date;
}

function getProctorTypeLabelVariant(
  proctorType: ExamCenterProctorType,
): 'proctor-1' | 'proctor-2' | 'proctor-3' {
  switch (proctorType) {
    case ExamCenterProctorType.Proctor_1:
      return 'proctor-1';
    case ExamCenterProctorType.Proctor_2:
      return 'proctor-2';
    case ExamCenterProctorType.Proctor_3:
      return 'proctor-3';
    default:
      throw new Error(`Unknown proctor type: ${proctorType}`);
  }
}

export const columns: GridColDef<ExamCenterProctorListItem>[] = [
  {
    field: 'fullName',
    headerName: 'ชื่อผู้คุมสอบ',
    flex: 1,
    minWidth: 200,
    sortable: false,
  },
  {
    field: 'type',
    headerName: 'ประเภทผู้คุมสอบ',
    width: 160,
    sortable: false,
    renderCell: ({ row }) => {
      return <ProctorTypeLabel variant={getProctorTypeLabelVariant(row.type)} />;
    },
  },
  {
    field: 'approvalDate',
    headerName: 'วันที่อนุมัติคำขอ',
    width: 164,
    renderCell: ({ row }) => {
      const { approvalDate } = row;

      return formatDateTime(approvalDate);
    },
  },
];
